import { request } from '@/plugins/axios'

// 医生列表
function DoctorList (data) {
    return request({
        url: '/doctor/list',
        method: 'get',
        params: data
    })
}

// 医生职称
const DoctorTitleList = [
    {
        type: 0,
        name: '全部'
    },
    {
        type: 1,
        name: '主任医师'
    },
    {
        type: 2,
        name: '副主任医师'
    },
    {
        type: 3,
        name: '主治医师'
    },
    {
        type: 4,
        name: '其他'
    }
]

// 排序
const RankList = [
    {
        type: 0,
		name: '综合排序',
		value: 'consult_general'
    },
    {
        type: 1,
		name: '问诊量',
		value: 'consult_count'
    },
    {
        type: 2,
		name: '好评度',
		value: 'comment'
    },
    {
        type: 3,
		name: '回复速度快',
		value: 'comment'
    },
    {
        type: 4,
		name: '价格从低到高',
		value: 'consult_fee'
	},
	{
        type: 5,
		name: '价格从高到低',
		value: 'consult_fee'
    }
]

// 医生列表首页-科室列表
function DepartmentListHome (data) {
    return request({
		url: '/tcmCustomizeStdDeptRelation/getCustomizeStdDeptList',
		method: 'get',
		params: data
    })
}

// 医生列表-科室列表
function DepartmentList (data) {
    return request({
		url: '/tcmStdDept/getStdDeptList',
		method: 'get',
		params: data
    })
}

// 医生列表-科室列表(从医院跳转过来)
function DepartmentListFromHospital (data) {
    return request({
		url: '/tcmStdDept/getStdDeptListByHospitalUuid',
		method: 'get',
		params: data
    })
}

// 医生列表-科室相关疾病列表
function DepDiseaseList (data) {
    return request({
		url: '/tcmDeptDiseaseRelation/tcmDeptDiseaseRelationList',
		method: 'get',
		params: data
    })
}

export {
    DoctorList,
	DoctorTitleList,
	DepartmentListHome,
	DepartmentList,
	DepartmentListFromHospital,
	DepDiseaseList,
	RankList
}
